import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { reviewsApi } from '../api/reviewsApi';
import { reviewKeys } from '../queryKeys';

export function useReputationOverview() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  return useQuery({
    queryKey: reviewKeys.reputation(locationId),
    queryFn: () => reviewsApi.getReputation(locationId),
    enabled: !!locationId,
    staleTime: 5 * 60 * 1000,
  });
}
